import { GlobalAxios } from "../axios/axios-config";
import { IPatientEncounterOrigin } from "../models/patient-encounter-origin";

const PATIENT_ENCOUNTER_ORIGIN_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/PatientEncounterOrigin/PatientEncounterOrigin";

export const patientEncounterOriginList = (params?: any) => {
  return GlobalAxios.get<IPatientEncounterOrigin[]>(
    PATIENT_ENCOUNTER_ORIGIN_ROUTE,
    { params },
  );
};
